import {Button} from 'antd';
import cn from 'classnames';
import React, {FC} from 'react';

import {ReactComponent as ArrowBackOutlined} from 'shared/assets/arrow-back-outlined.svg';
import {useAppHistory} from 'shared/hooks/use-app-history';

import s from './content-unavailable.module.less';

interface IContentUnavailableProps {
    message?: string;
    className?: string;
}

export const ContentUnavailable : FC<IContentUnavailableProps> = ({
    message = 'Недоступно к просмотру',
    className,
}: IContentUnavailableProps) => {
    const history = useAppHistory();
    return (
        <div
            className={cn(s['content-unavailable'], className)}
        >
            <div
                className={s['content-unavailable__text']}
            >
                {message}
            </div>
            <Button
                type="default"
                icon={<ArrowBackOutlined />}
                onClick={() => {
                    history.go(-1);
                }}
            >
                Вернуться назад
            </Button>
        </div>
    );
};
